import { FC } from "react";
import { MessageCircle, Link as LinkIcon, Zap } from "lucide-react";

export const FeaturesSection: FC = () => {
  return (
    <section className="bg-gradient-to-b from-white/50 to-primary/5 backdrop-blur-sm py-20 dark:from-black/20 dark:to-primary/20">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-black text-center mb-12 bg-gradient-to-r from-primary to-green-500 bg-clip-text text-transparent">
          Selamat Datang di jual.in ⭐
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {[
            {
              icon: <MessageCircle className="w-12 h-12 text-primary" />,
              title: "Template Pesan",
              description: "Buat template pesan WhatsApp yang dapat disesuaikan untuk setiap produk",
            },
            {
              icon: <LinkIcon className="w-12 h-12 text-primary" />,
              title: "Domain jual.in",
              description: "Dapatkan link produk dengan domain jual.in yang mudah diingat",
            },
            {
              icon: <Zap className="w-12 h-12 text-primary" />,
              title: "Gratis",
              description: "Langsung buat link produk tanpa perlu login. Selamanya gratis!",
            },
          ].map((feature, index) => (
            <div
              key={index}
              className="p-8 bg-white dark:bg-gray-800 rounded-2xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 border border-primary/20"
            >
              <div className="mb-4">{feature.icon}</div>
              <h3 className="text-2xl font-bold mb-3 text-primary">{feature.title}</h3>
              <p className="text-gray-600 dark:text-gray-300 text-lg">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};